export const HISTORY_TYPE_PARAM = 'type';

export const HISTORY_CATEGORIES = [
  { label: 'Medical', value: 'medical', isDefault: true },
  { label: 'Surgical', value: 'surgical' },
  { label: 'Family', value: 'family' },
  { label: 'Social', value: 'social' }
];

const DEFAULT_CATEGORY = HISTORY_CATEGORIES.find((category) => category.isDefault).value;

export const resolveHistoryCategory = (value) =>
  HISTORY_CATEGORIES.some((category) => category.value === value) ? value : DEFAULT_CATEGORY;
